<template>
  <el-dialog
    draggable
    v-model="newIsShow"
    :show-close="isDisplayMemberInfo"
    :before-close="closeDialog"
    lock-scroll
    destroy-on-close
    ref="dailog"
    center
    class="home-dialog small"
    :title="disabled ? $t('Auto-redemption') : $t('Redeem-2')"
  >
    <div class="dialog-wrapper" style="overflow-x: hidden">
      <p class="dialog-wrapper-title">
        {{
          disabled
            ? $t('You have purchased the Enterprise Plan. Do you want to auto-redeem your plan?')
            : $t('Please enter your purchased UPDF redemption code, the successful redemption will increase the number of authorized licenses for the company.')
        }}
      </p>

      <p class="dialog-wrapper-code">{{ $t('Redemption code') }}:</p>
      <el-input class="dialog-wrapper-input" ref="inputRef" v-model="newReedemCode" :disabled="disabled">
        <template #suffix>
          <img src="@/assets/copy-icon.png" class="dialog-wrapper-input-icon" @click="copyReedemCode" />
        </template>
      </el-input>
      <span v-if="userNum && userNum != -1 && isAiRedeemCode" class="dialog-wrapper-tip">{{ $t('Amount of AI plans to be redeemed') }}:{{ userNum }}</span>
      <span v-if="userNum && userNum != -1 && !isAiRedeemCode && isSignRedeemCode" class="dialog-wrapper-tip">{{ $t('Amount of Sign plans to be redeemed') }}:{{ userNum }}</span>
      <span v-if="userNum && userNum != -1 && !isAiRedeemCode && !isSignRedeemCode" class="dialog-wrapper-tip">{{ $t('Amount of UPDF plans to be redeemed') }}:{{ userNum }}</span>
      <span v-if="userNum == 0 || userNum == -1" class="dialog-wrapper-tip-err">{{ userNum == 0 ? $t('Invalid redemption code') : '' }}</span>
    </div>

    <template #footer v-if="!isDisplayMemberInfo">
      <el-button size="large" class="cancel" @click="closeDialog">{{ $t('Cancel') }}</el-button>
      <el-button size="large" class="ok" @click="enterDailog" type="primary">
        {{ $t('Ok') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { getCurrentInstance, ref, watch, onMounted } from 'vue'
import { useVModel, useClipboard } from '@vueuse/core'
import { useOffsetCoupon } from '@/api/user/user'
import { offsetCoupon } from '@/api/company/company'
import { ElMessage } from 'element-plus'
import { setLocalStorage } from '@/libs/utils'
const props = defineProps({
  isShow: {
    type: Boolean,
    default: false,
  },
  reedemCode: {
    type: String,
  },
  disabled: {
    type: Boolean,
  },
})

const emits = defineEmits(['update:isShow', 'on-close-dialog', 'on-init-chart', 'update:reedemCode'])
const newIsShow = useVModel(props, 'isShow', emits)
const newReedemCode = useVModel(props, 'reedemCode', emits)
const { $t } = getCurrentInstance().proxy
const inputRef = ref()
const userNum = ref()
const isAiRedeemCode = ref(false)
const isSignRedeemCode = ref(false)
const { copy, copied } = useClipboard()

const copyReedemCode = () => {
  const text = props.reedemCode
  copy(text)
}

const closeDialog = () => {
  newReedemCode.value = ''
  emits('on-close-dialog')
}

const enterDailog = async () => {
  const res = await useOffsetCoupon(newReedemCode.value)
  if (res.code === 200) {
    ElMessage({
      type: 'success',
      message: $t('Redeemed successfully'),
    })

    emits('on-init-chart')
    closeDialog()
  }
}

watch(copied, () => {
  if (copied.value) {
    ElMessage({
      message: $t('Information copied'),
      type: 'success',
    })
  }
})

watch(newReedemCode, () => {
  if (/^[\s\S]{16}$/.test(newReedemCode.value)) {
    initUserNum()
  } else if (newReedemCode.value) {
    userNum.value = 0
  } else if (!newReedemCode.value) {
    userNum.value = null
  }
})

const initUserNum = async () => {
  try {
    const res = await offsetCoupon(newReedemCode.value)

    if (res.code === 200) {
      userNum.value = res.data.number
      isAiRedeemCode.value = res.data.isAI
      isSignRedeemCode.value = res.data.isSign
    }
  } catch (error) {
    userNum.value = -1
    setLocalStorage('companyReedemCode', '')
    ElMessage.error($t(`http_error_${error.code}`))
  }
}

onMounted(() => {
  setLocalStorage('companyReedemCode', '')
  if (props.disabled || (!props.disabled && newReedemCode.value)) {
    initUserNum()
  }
})
</script>
<style lang="scss">
.home-dialog {
  width: 592px;

  .el-dialog__body {
    background: #f7f7f7;
    padding-top: 24px;
    padding-left: 32px;
    padding-right: 32px;
  }

  .el-dialog__footer {
    background: #f7f7f7;
    border-radius: 0px 0px 15px 15px;
    padding-top: 55px;
  }

  &-footer {
    margin-top: 55px;
  }
}
@media screen and (max-width: 640px) {
  .home-dialog {
    width: 85%;
  }
}
</style>
<style scoped lang="scss">
:deep(.el-dialog) {
  width: 592px;
}

.dialog-wrapper {
  &-title {
    font-family: 'SF Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */

    color: rgba(53, 53, 53, 0.8);
  }

  &-code {
    font-family: 'SF Pro';
    font-style: normal;
    font-weight: 590;
    font-size: 18px;
    line-height: 21px;
    margin-top: 24px;
    color: #353535;
  }

  &-input {
    margin-top: 12px;

    &-icon {
      width: 17px;
      height: 17px;
      cursor: pointer;
    }
  }

  &-tip {
    color: #36a8e8;
    font-size: 14px;
    margin-left: 2px;
    margin-top: 10px;
  }

  &-tip-err {
    color: #ff8080;
  }
}
</style>
